/**
 * 整数哈希函数（让相邻 ID 的颜色差异更大）
 */
function intHash(n) {
  n |= 0;
  n = (n + 0x9e3779b9) | 0;
  let x = Math.imul(n ^ (n >>> 16), 0x85ebca6b);
  x = Math.imul(x ^ (x >>> 13), 0xc2b2ae35);
  return (x ^ (x >>> 16)) >>> 0;
}

/**
 * HSL 转 RGB
 */
function hslToRgb(h, s, l) {
  s /= 100;
  l /= 100;
  const k = n => (n + h / 30) % 12;
  const a = s * Math.min(l, 1 - l);
  const f = n => l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
  return [255 * f(0), 255 * f(8), 255 * f(4)];
}

/**
 * 根据 ID 生成颜色集 { bgColor, textColor }
 */
export function getColorPairById(id) {
  const sat = 65;
  const light = 55;

  let hue;
  if (typeof id === "number") {
    hue = intHash(id) % 360;
  } else {
    // 字符串哈希
    let hash = 0;
    const str = String(id);
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash) / 2;
    }
    hue = Math.abs(hash) % 360;

    // console.log(id, hash);

  }

  const bgColor = `hsl(${hue}, ${sat}%, ${light}%)`;

  const [r, g, b] = hslToRgb(hue, sat, light);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  const textColor = yiq > 128 ? "#000000" : "#FFFFFF";
  // console.log(id, bgColor, textColor);

  return { bgColor, textColor };
}
